import React, { Component } from 'react'
import Datum from './Datum'
import AdditionalRecordings from './AdditionalRecordings'

import { withStyles } from '@material-ui/core/styles'

const styles = {
  dataWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}

class DataList extends Component {
  render () {
    const { data, truncated, classes, size, width, styles } = this.props
    return (
      <div>
        <div className={classes.dataWrapper} style={styles}>
          {
            data.map(datum => <Datum datum={datum} size={size} width={width} margin={8} styles={styles}/>)
          }
          {
            truncated ? <AdditionalRecordings /> : ''
          }
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(DataList)



// WEBPACK FOOTER //
// ./src/components/DataList.js